export class ProposalCoverageInsuredDO {
    
    public id: Number = null;
    public getid(): Number {
        return this.id;
    }
    public setid(value: Number) {
        this.id = value;
    }
    
    public roleCd: String = null;
    public getroleCd(): String {
        return this.roleCd;
    }
    public setroleCd(value: String) {
        this.roleCd = value;
    }
    
    public clientRefGuid: String = null;
    public getclientRefGuid(): String {
        return this.clientRefGuid;
    }
    public setclientRefGuid(value: String) {
        this.clientRefGuid = value;
    }
    
    public customerId: String = null;
    public getcustomerId(): String {
        return this.customerId;
    }
    public setcustomerId(value: String) {
        this.customerId = value;
    }
    
    public vehicleId: Number = null;
    public getvehicleId(): Number {
        return this.vehicleId;
    }
    public setvehicleId(value: Number) {
        this.vehicleId = value;
    }
    
    public vehicleRefGuid: String = null;
    public getvehicleRefGuid(): String {
        return this.vehicleRefGuid;
    }
    public setvehicleRefGuid(value: String) {
        this.vehicleRefGuid = value;
    }
    
    public propertyId: Number = null;
    public getpropertyId(): Number {
        return this.propertyId;
    }
    public setpropertyId(value: Number) {
        this.propertyId = value;
    }
    
    public propertyRefGuid: String = null;
    public getpropertyRefGuid(): String {
        return this.propertyRefGuid;
    }
    public setpropertyRefGuid(value: String) {
        this.propertyRefGuid = value;
    }
    
    public relatedToBeneficiaryCd: String = null;
    public getrelatedToBeneficiaryCd(): String {
        return this.relatedToBeneficiaryCd;
    }
    public setrelatedToBeneficiaryCd(value: String) {
        this.relatedToBeneficiaryCd = value;
    }
    
    public medicalClassCd: String = null;
    public getmedicalClassCd(): String {
        return this.medicalClassCd;
    }
    public setmedicalClassCd(value: String) {
        this.medicalClassCd = value;
    }
    
    public defaultSumInsured: Number = null;
    public getdefaultSumInsured(): Number {
        return this.defaultSumInsured;
    }
    public setdefaultSumInsured(value: Number) {
        this.defaultSumInsured = value;
    }
    
    public entryAge: Number = null;
    public getentryAge(): Number {
        return this.entryAge;
    }
    public setentryAge(value: Number) {
        this.entryAge = value;
    }
    
    public idType: String = null;
    public getidType(): String {
        return this.idType;
    }
    public setidType(value: String) {
        this.idType = value;
    }
    
    public uwClassCd: String = null;
    public getuwClassCd(): String {
        return this.uwClassCd;
    }
    public setuwClassCd(value: String) {
        this.uwClassCd = value;
    }
    
    public uwDecisionCd: String = null;
    public getuwDecisionCd(): String {
        return this.uwDecisionCd;
    }
    public setuwDecisionCd(value: String) {
        this.uwDecisionCd = value;
    }
    
    public uwDecisionValue: String = null;
    public getuwDecisionValue(): String {
        return this.uwDecisionValue;
    }
    public setuwDecisionValue(value: String) {
        this.uwDecisionValue = value;
    }
    
    public proposalCoverageInsuredAccessories: [];
    public getproposalCoverageInsuredAccessories(): [] {
        return this.proposalCoverageInsuredAccessories;
    }
    public setproposalCoverageInsuredAccessories(value: []) {
        this.proposalCoverageInsuredAccessories = value;
    }
    
    public proposalCoverageInsuredLoadings: [];
    public getproposalCoverageInsuredLoadings(): [] {
        return this.proposalCoverageInsuredLoadings;
    }
    public setproposalCoverageInsuredLoadings(value: []) {
        this.proposalCoverageInsuredLoadings = value;
    }
    
    public proposalCoverageInsuredDiscounts: [];
    public getproposalCoverageInsuredDiscounts(): [] {
        return this.proposalCoverageInsuredDiscounts;
    }
    public setproposalCoverageInsuredDiscounts(value: []) {
        this.proposalCoverageInsuredDiscounts = value;
    }
    
    public proposalCovInsuredInsurables: [];
    public getproposalCovInsuredInsurables(): [] {
        return this.proposalCovInsuredInsurables;
    }
    public setproposalCovInsuredInsurables(value: []) {
        this.proposalCovInsuredInsurables = value;
    }
    
    public proposalCoverageInsuredAdditionalFields: [];
    public getproposalCoverageInsuredAdditionalFields(): [] {
        return this.proposalCoverageInsuredAdditionalFields;
    }
    public setproposalCoverageInsuredAdditionalFields(value: []) {
        this.proposalCoverageInsuredAdditionalFields = value;
    }
    
    public mileage: Number = null;
    public getmileage(): Number {
        return this.mileage;
    }
    public setmileage(value: Number) {
        this.mileage = value;
    }
    
    public ageCategoryCd: String = null;
    public getageCategoryCd(): String {
        return this.ageCategoryCd;
    }
    public setageCategoryCd(value: String) {
        this.ageCategoryCd = value;
    }
    
    public appliedForSeatingCapacity: Number = null;
    public getappliedForSeatingCapacity(): Number {
        return this.appliedForSeatingCapacity;
    }
    public setappliedForSeatingCapacity(value: Number) {
        this.appliedForSeatingCapacity = value;
    }
}